// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call/call_requests.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { InitialParticipant } from './call_model_pb';
import { file_call_call_model } from './call_model_pb';

/**
 * Describes the file call/call_requests.proto.
 */
export const file_call_call_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChhjYWxsL2NhbGxfcmVxdWVzdHMucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0IiMKEUNyZWF0ZUNhbGxSZXF1ZXN0Eg4KBmNoYXRJZBgBIAEoAyJHChJEZWNsaW5lQ2FsbFJlcXVlc3QSEQoJY2hhbm5lbElkGAEgASgJEhMKBnJlYXNvbhgCIAEoCUgAiAEBQgkKB19yZWFzb24irgEKEUNyZWF0ZVJvb21SZXF1ZXN0EhAKCHJvb21OYW1lGAEgASgJEhMKC2FsbG93R3Vlc3RzGAIgASgIEhoKEndhaXRpbmdSb29tRW5hYmxlZBgDIAEoCBIPCgd3ZWJpbmFyGAQgASgIEkUKE2luaXRpYWxQYXJ0aWNpcGFudHMYBSADKAsyKC5jb20uZ2VtLmJmZi5jb250cmFjdC5Jbml0aWFsUGFydGljaXBhbnRCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z',
    [file_call_call_model]
  );

/**
 * @generated from message com.gem.bff.contract.CreateCallRequest
 */
export type CreateCallRequest = Message<'com.gem.bff.contract.CreateCallRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.CreateCallRequest.
 * Use `create(CreateCallRequestSchema)` to create a new message.
 */
export const CreateCallRequestSchema: GenMessage<CreateCallRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 0);

/**
 * @generated from message com.gem.bff.contract.DeclineCallRequest
 */
export type DeclineCallRequest = Message<'com.gem.bff.contract.DeclineCallRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: optional string reason = 2;
   */
  reason?: string;
};

/**
 * Describes the message com.gem.bff.contract.DeclineCallRequest.
 * Use `create(DeclineCallRequestSchema)` to create a new message.
 */
export const DeclineCallRequestSchema: GenMessage<DeclineCallRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 1);

/**
 * @generated from message com.gem.bff.contract.CreateRoomRequest
 */
export type CreateRoomRequest = Message<'com.gem.bff.contract.CreateRoomRequest'> & {
  /**
   * @generated from field: string roomName = 1;
   */
  roomName: string;

  /**
   * @generated from field: bool allowGuests = 2;
   */
  allowGuests: boolean;

  /**
   * @generated from field: bool waitingRoomEnabled = 3;
   */
  waitingRoomEnabled: boolean;

  /**
   * @generated from field: bool webinar = 4;
   */
  webinar: boolean;

  /**
   * @generated from field: repeated com.gem.bff.contract.InitialParticipant initialParticipants = 5;
   */
  initialParticipants: InitialParticipant[];
};

/**
 * Describes the message com.gem.bff.contract.CreateRoomRequest.
 * Use `create(CreateRoomRequestSchema)` to create a new message.
 */
export const CreateRoomRequestSchema: GenMessage<CreateRoomRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 2);
